module.exports = __webpack_public_path__ + "img/check-green.2651f87a.svg";